import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Form } from 'react-form';
import { connect } from 'react-redux';
import Dialog from '../UI/Dialog';
import CheckboxElement from '../UI/Checkbox';
import SwitchToggle from '../UI/SwitchToggle';
import Breadcrumb from '../UI/Breadcrumb';
import { links } from '../../utils/constants';
import InputTabs from '../UI/InputTabs';
import { addListItem, getTags, getListItems, editList } from '../../store/actions';
import { validate } from '../../utils/constants';
import moment from 'moment';
import SearchForm from '../UI/SearchForm';
import DeactivateDialog from './DeactivateDialog';
import Pagination from '../UI/Pagination';
import PromptDialog from './PromptDialog';


class List extends Component {

    state = {
        isDialogOpen: false,
        isEditDialogOpen: false,
        page: 1,
        searchedValue: null,
        isDeactivateDialogOpen: false,
        isDeletingDialogOpen: false,
        isCancelDeactivationDialogOpen: false,
        deactivatingListId: null,
        deletingListId: null,
        cancelingDeactivationListId: null,
        add_tagsRequiredError: false
    };

    componentDidMount() {
        this.props.getTags();
        this.props.getListItems(this.props.match.params.menuId, 1, null);
    }

    openDeactivateDialog = (listId, isActive) => {
        this.changeStatus(listId, !isActive);
        // if (isActive) {
        //     this.setState({isDeactivateDialogOpen: true, deactivatingListId: listId});
        // } else {
        //     this.changeStatus(listId, true);
        // }
    };

    cancelDeactivation = () => {
        const data = { deactivation_date: null };
        this.props.editList(this.state.cancelingDeactivationListId, data).then(res => {
            const { menuId } = this.props.match.params;
            this.props.getListItems(menuId, this.state.page, this.state.searchedValue);
        });
        this.setState({ isCancelDeactivationDialogOpen: false, cancelingDeactivationListId: null })
    };

    changeStatus = (listId, status, date) => {
        const data = { };
        if (date) {
            data.deactivation_date = moment(date).format('YYYY-MM-DD');
        } else {
            data.is_active = status
        }
        this.props.editList(listId, data).then(res => {
            const { menuId } = this.props.match.params;
            this.props.getListItems(menuId, 1, null);
        });
    };

    onSubmitDeactivateStatusHandler = values => {
        if(values.deactivate && values.deactivate === 'deactivate_from' && values.date) {
            this.changeStatus(this.state.deactivatingListId, false, values.date);
        } else {
            this.changeStatus(this.state.deactivatingListId, false);
        }
        this.setState({isDeactivateDialogOpen: false});
    };

    deleteList = () => {
        const data = { is_deleted: true };
        this.props.editList(this.state.deletingListId, data).then(res => {
            const { menuId } = this.props.match.params;
            this.props.getListItems(menuId, this.state.page, this.state.searchedValue);
        });
        this.setState({ isDeletingDialogOpen: false, deletingListId: null });
    };

    getTagName = id => {
        const tagObj = this.props.tags.find(tag => tag.id === id);
        return tagObj.name;
    };

    onSubmitSearchHandler = searchValue => this.props.getListItems(this.props.match.params.menuId, 1, searchValue);

    pageChangeHandler = page => this.props.getListItems(this.props.match.params.menuId, page.selected + 1, null);

    onSubmitAddListItemHandler = values => {
      const tags = values.tags ? Object.keys(values.tags).filter(id => values.tags[id]).map(tag => parseInt(tag, 10)): null;
      if (!tags || tags.length === 0){
          this.setState({ add_tagsRequiredError: true });
          return;
      }
      const data = {
          tags,
          menu: +this.props.match.params.menuId,
          name_en: values.list_heading_en,
          name_ar: values.list_heading_ar,
      };
        this.props.addListItem(data).then(res => {
            this.props.getListItems(+this.props.match.params.menuId);
            this.setState({ isDialogOpen: false, add_tagsRequiredError: false });
        })
    };

    getTagStatus = id => {
        return this.state.selectedListItem.tags.indexOf(+id) !== -1;
    };

    onSubmitEditListItemHandler = values => {
        const tags = values.tags ? Object.keys(values.tags).filter(id => values.tags[id]).map(tag => parseInt(tag, 10)): null;
        if (!tags || tags.length === 0){
            this.setState({ edit_tagsRequiredError: true });
            return;
        }
        const data = {
            tags,
            menu: +this.props.match.params.menuId,
            name_en: values.list_heading_en,
            name_ar: values.list_heading_ar,
        };
        this.props.editList(this.state.selectedListItem.id, data).then(res => {
            this.props.getListItems(+this.props.match.params.menuId);
            this.setState({ isEditDialogOpen: false, edit_tagsRequiredError: false });
        })
    };

    renderLists = () => {
        if (!this.props.listItems || !this.props.tags) return null;
        const lists = this.props.listItems.map(listItem => {
            let deactivationDate = null;
            if (listItem.deactivation_date) {
                deactivationDate = (
                    <p>
                        <span className="color-grey50">Deactivated from: </span>
                        <span className="color-primary ml-5">{ listItem.deactivation_date }</span>
                    </p>
                );
            }
            return (
                <li className="card" key={listItem.id}>
                    <div className="action"
                         style={{cursor: 'pointer'}}
                         onClick={ () => this.setState({ isEditDialogOpen: true, selectedListItem: listItem }) } >

                        <i className="fa fa-pencil"></i>
                    </div>
                    <div className="inner-top">

                    </div>
                    <div className="inner">
                        <h2>{listItem.name_en}</h2>
                        <ul className="tags text-center mt-20">
                            { listItem.tags.map(tag => <li key={tag}>{this.getTagName(tag)}</li>  ) }
                        </ul>
                    </div>
                    <div className="options text-center flex-center-y justify-between">
                        <Link to={links.Item(this.props.match.params.id, this.props.match.params.restId, this.props.match.params.menuId, listItem.id)} className="pointer"><i className="fa fa-plus font-sm mr-5"></i>Add Items</Link>
                        <div onClick={ () => this.openDeactivateDialog(listItem.id, listItem.is_active) }>
                            <SwitchToggle notForm toggled={listItem.is_active}/>
                        </div>
                    </div>
                    <div className="action" style={{marginRight: '20px'}}>
                        {/*{ deactivationDate && <Link to="#" onClick={ () => this.setState({ isCancelDeactivationDialogOpen: true, cancelingDeactivationListId: listItem.id }) }>*/}
                            {/*<span className="cancel">&#10006;</span>*/}
                        {/*</Link>}*/}
                        <Link to="#" className="color-red" onClick={() => this.setState({ isDeletingDialogOpen: true, deletingListId: listItem.id })}>
                            <span className="trash fa fa-trash"></span>
                        </Link>
                    </div>
                </li>
            );
        });
        return lists;
    };

    onSearchChangeHandler = () => { };

    render() {
        let pagination = null;
        if ( this.props.pageCount && this.props.pageCount > 1) {
            pagination = <Pagination pageChangeHandler={ this.pageChangeHandler }
                                     driversPageCount={ this.props.pageCount } />;
        }
        return (
            <React.Fragment>
                <div className="page-title">
                    <div className="container">
                        <div className="row flex-center-y justify-between">
                            <div className="col-xs-9 text-left">
                                <h1 className="color-grey">Beverage Menu</h1>
                            </div>
                            <SearchForm col onSubmit={ this.onSubmitSearchHandler }
                                        onChange={ this.onSearchChangeHandler } />
                        </div>
                    </div>
                </div>
                <div className="container">
                    <Breadcrumb from={[{link: '/customers', label: 'Customers Administration'},
                                     {link: `/customers/${this.props.match.params.id}/edit`, label: 'Edit Customer'},
                                     {link: `/customers/${this.props.match.params.id}/edit/${this.props.match.params.restId}/menu`, label: 'Add Menu'}]} current="Add List"/>
                </div>
                <div className="container inner-padding box py-15">
                    <div className="box-body">
                        {/* START: Card Items Container */}
                        <ul className="card-items large">
                            {/* START: Add New Card */}
                            <li className="card add">
                                <button className="no-style" onClick={() => this.setState({ isDialogOpen: true, add_tagsRequiredError: false })} >
                                    <i className="fa fa-plus"></i>
                                    <p>Add List Item</p>
                                </button>
                            </li>
                            {/* END: Add New Card */}
                            { this.renderLists() }
                        </ul>
                        {/* END: Card Items Container */}
                        { pagination }
                    </div>
                </div>

                <DeactivateDialog open={ this.state.isDeactivateDialogOpen }
                                  close={ () => this.setState({ isDeactivateDialogOpen: false }) }
                                  onSubmitDialog={ this.onSubmitDeactivateStatusHandler } />

                {/* START: Add List Popup */}
                <Dialog open={this.state.isDialogOpen}
                        handleClose={ () => this.setState({ isDialogOpen: false }) }>
                    <Form onSubmit={ this.onSubmitAddListItemHandler }>
                        { formApi => (
                            <form onSubmit={formApi.submitForm}>
                                <div className="popup-title">
                                    <h2>Add List</h2>
                                </div>
                                <div className="popup-body">
                                    <InputTabs label="List heading"
                                               validations={ [...validate.$required] }
                                               formApi={formApi}
                                               field="list_heading"
                                               value="list_heading" />
                                    <ul>
                                        {
                                            this.props.tags ? this.props.tags.map(tag => {
                                                return (
                                                    <li className="my-10" key={tag.id}>
                                                        <CheckboxElement formApi={formApi} field={'tags.' + tag.id} label={ tag.name }/>
                                                    </li>
                                                );
                                            }) : null
                                        }
                                    </ul>
                                    { formApi.errors && formApi.errors.tags && Object.keys(formApi.errors.tags).length === this.props.tags.length ? <span className="error-msg">You should choose at least one of the tags </span>: null }
                                </div>
                                <div className="popup-meta flex justify-end">
                                    <button type="button" className="no-style w-600 pointer mx-20" onClick={ () => this.setState({ isDialogOpen: false }) }>Cancel</button>
                                    <button type="submit" className="btn filled primary min-120">Save</button>
                                </div>
                            </form>
                        )}
                    </Form>
                    <button className="no-style close-btn" onClick={ () => this.setState({ isDialogOpen: false }) }>×</button>
                </Dialog>
                {/* END: Add List Popup */}

                {/* START: Edit List Popup */}
                <Dialog open={this.state.isEditDialogOpen} handleClose={ () => this.setState({ isEditDialogOpen: false }) }>
                    <Form onSubmit={ this.onSubmitEditListItemHandler }>
                        { formApi => (
                            <form onSubmit={formApi.submitForm}>
                                <div className="popup-title">
                                    <h2>Edit List</h2>
                                </div>
                                <div className="popup-body">
                                    <InputTabs label="List heading"
                                               formApi={formApi}
                                               validations={ [...validate.$required] }
                                               field="list_heading"
                                               value="list_heading" defaultValue={this.state.selectedListItem.name_en} />
                                    <ul>
                                        {
                                            this.props.tags ? this.props.tags.map(tag => {
                                                return (
                                                    <li className="my-10" key={tag.id}>
                                                        <CheckboxElement formApi={formApi}
                                                                         defaultValue={ this.getTagStatus(tag.id) }
                                                                         field={'tags.' + tag.id}
                                                                         label={ tag.name } />

                                                    </li>
                                                );
                                            }) : null
                                        }
                                    </ul>
                                </div>
                                <div className="popup-meta flex justify-end">
                                    <button type="button" className="no-style w-600 pointer mx-20" onClick={ () => this.setState({ isEditDialogOpen: false }) }>Cancel</button>
                                    <button type="submit" className="btn filled primary min-120">Save</button>
                                </div>
                            </form>
                        )}
                    </Form>
                    <button className="no-style close-btn" onClick={ () => this.setState({ isEditDialogOpen: false }) }>×</button>
                </Dialog>
                {/* END: Edit List Popup */}

                <PromptDialog open={ this.state.isCancelDeactivationDialogOpen }
                              prompt={'Are you sure you want to cancel the deactivation?'}
                              close={ () => this.setState({ isCancelDeactivationDialogOpen: false }) }
                              changeStatus={ this.cancelDeactivation }/>

                <PromptDialog open={ this.state.isDeletingDialogOpen }
                              prompt={'Are you sure you want to delete the list?'}
                              close={ () => this.setState({ isDeletingDialogOpen: false }) }
                              changeStatus={ this.deleteList } />
            </React.Fragment>
        );
    }
}

const mapStateToProps = state => {
    return {
        tags: state.customer.tags,
        listItems: state.customer.listItems,
        pageCount: state.customer.pageCount
    }
};


const mapDispatchToProps = dispatch => {
    return {
        addListItem: data => dispatch( addListItem(data) ),
        editList: (id, data) => dispatch( editList(id, data) ),
        getListItems: (id, page, searchValue) => dispatch( getListItems(id, page, searchValue) ),
        getTags: () => dispatch( getTags() ),
    }
};

export default connect(mapStateToProps, mapDispatchToProps)( List );



// WEBPACK FOOTER //
// ./src/components/Customer-administrator/List.js